import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=4f19b128&scoped=true"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"
import style0 from "./Communication.vue?vue&type=style&index=0&id=4f19b128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19b128",
  null
  
)

export default component.exports